<template>
  <div class="wrapper">11
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card>
            <div slot="header">
              <b-row>
                <b-col cols="6">
                  <span>{{ $t('role_new_title') }}</span>
                </b-col>
              </b-row>
            </div>
            <div v-if="spinners.contentIsLoading" class="text-center">
              <b-spinner type="grow" variant="primary"/>
            </div>
            <div v-else>
              <b-row>
                <b-col cols="4" md="4">
                  <b-form-group>
                    <label>{{ $t('title') }}</label>
                    <b-form-input type="text" :placeholder=" 'role_title_placeholder' | translate('global') "
                                  :class="{ 'is-invalid' : errorMsg.name}"
                                  v-model="name"/>
                    <div class="invalid-feedback" v-if="errorMsg.name">{{ errorMsg.name[0] }}</div>
                  </b-form-group>
                </b-col>
                <b-col cols="4" md="4">
                  <b-form-group>
                    <label>{{ $t('address') }}</label>
                    <b-form-input type="text" :placeholder=" 'role_title_placeholder' | translate('global') "
                                  :class="{ 'is-invalid' : errorMsg.address}"
                                  v-model="address"/>
                    <div class="invalid-feedback" v-if="errorMsg.address">{{ errorMsg.address[0] }}</div>
                  </b-form-group>
                </b-col>
                <b-col cols="4" md="4">
                  <b-form-group>
                    <label>{{ $t('device.pin') }}</label>
                    <b-form-input type="text" :placeholder=" 'role_title_placeholder' | translate('global') "
                                  :class="{ 'is-invalid' : errorMsg.pin}"
                                  v-model="pin"/>
                    <div class="invalid-feedback" v-if="errorMsg.pin">{{ errorMsg.pin[0] }}</div>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
            <div slot="footer">
              <b-button type="submit" variant="success" @click="onSave()">
                <b-spinner v-if="spinners.isSaving" type="grow" small/>
                {{ $t('save') }}
              </b-button>
              <b-button :to="{ name: 'Roles' }" type="reset" variant="danger" class="ml-2">
                {{ $t('cancel') }}
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    {{ deviceCreateData }}
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import forEach from 'lodash.foreach';
import { mapGetters, mapActions } from 'vuex';
import VuexTypes from '@/store/types/index';

const DevicesTypes = VuexTypes.devices;

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      errorMsg: {}
    };
  },
  components: {},
  computed: {
    ...mapGetters('Devices', [
      'deviceCreateData',
    ]),
  },
  watch: {
    deviceCreateData: {
      handler: function () {
        if (this.deviceCreateData.status === statuses.LOADED) {
          this.fillData();
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    deviceCreate: {
      handler: function () {
        this.spinners.isSaving = false;
        this.errorMsg = {};
        if (this.deviceCreate.status === statuses.LOADED) {
          this.alertSuccess();
          this.$router.push({ name: 'ApplyRoleEdit', params: { id: this.deviceCreate.data.id } });
        } else if (this.deviceCreate.status === statuses.ERROR) {
          this.alertError();
          this.errorMsg = this.deviceCreate.data.data.errors;
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Devices', [
      DevicesTypes.DEVICE_CREATE_DATA,
      DevicesTypes.DEVICE_CREATE
    ]),
    fillData() {
      const permissions = [];

      if (this.roleCreateData.data.permissions) {
        forEach(this.roleCreateData.data.permissions, (permission) => {
          permissions.push({
            value: permission['id'],
            text: this.$t(permission['name'], 'global')
          });
        });
      }
      this.allPermissions = permissions;
    },
    getData() {
      this.DEVICE_CREATE_DATA();
    },
    onSave() {
      this.spinners.isSaving = true;
      this.DEVICE_CREATE({ name: this.device });
    },
  }
};

</script>

<style scoped>
</style>
